import { FC } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import { Crud } from 'core/types/Crud'
import { IQbrDocumentInitiative } from 'partner360/models/qbr/iQbrDocumentInitiative'

import { InitiativesDialogContent } from './components/initiativesDialogContent/InitiativesDialogContent'
import { InitiativesDialogHeader } from './components/initiativesDialogHeader/InitiativesDialogHeader'

interface IInitiativesModalProps {
  isOpen: boolean
  dataSource: Crud<IQbrDocumentInitiative>
  onAddInitiatives: (checkedInitiatives: IQbrDocumentInitiative[]) => void
  onClose: () => void
}

export const InitiativesModal: FC<IInitiativesModalProps> = ({
  isOpen,
  dataSource,
  onAddInitiatives,
  onClose,
}) => {
  if (!isOpen) {
    return null
  }

  return (
    <ModalDialog
      show
      header={InitiativesDialogHeader}
      size="lg"
      content={InitiativesDialogContent}
      contentProps={{
        dataSource,
        onAdd: onAddInitiatives,
      }}
      onClose={onClose}
    />
  )
}
